import React from 'react'

import { withRouter } from 'react-router-dom'

import { AD_STATUS } from '../components/eezee-ads/table/ad-status'

import { message } from 'antd'

import {
    _getAd,
    _postApproveAd,
    _postTerminateAd,
    _postPauseAd,
    _postRemoveAd
} from '../services'

import EezeeAdsProfile from '../components/eezee-ads/profile'

import { ACTIONS } from '../components/eezee-ads/profile'

class EezeeAdsProfilePage extends React.Component {
    
    render(){

        if( !this.state.ad ){
            return "Loading..."
        }

        return (
            <EezeeAdsProfile
                onClick={this.handleClick}
                ad={this.state.ad}
            />
        )
    }

    constructor(props){
        super(props)

        this.state = {
            ad: false
        }
    }

    componentDidMount(){
        
        const { adId } = this.props.match.params

        _getAd({ adId })
        .then( res => {
            this.setState({ ad: res.data.ad })
        })
    }

    handleClick = (action) => {

        message.loading("Loading", 0)

        switch( action ){
            case ACTIONS.APPROVE:
                return this.handleApprove()
            case ACTIONS.TERMINATE:
                return this.handleTerminate()
            case ACTIONS.PAUSE:
                return this.handlePause()
            case ACTIONS.REMOVE:
                return this.handleRemove()
        }
    }

    handleApprove = () => {

        const { adId } = this.props.match.params

        _postApproveAd({adId})
        .then( res => {
            
            message.destroy()
            message.success("Success")

            if( res.data.success ){
                this.setState({
                    ad: {
                        ...this.state.ad,
                        status: AD_STATUS.active,
                        approved: true
                    }
                })
            }

        })
    }

    handleTerminate = () => {

        const { adId } = this.props.match.params

        message.destroy()
        message.success("Success")

        _postTerminateAd({ adId })
        .then( res => {
            
            if( res.data.success ){
                this.setState({
                    ad: {
                        ...this.state.ad,
                        status: AD_STATUS.terminated
                    }
                })
            }

        })

    }

    
    handlePause = () => {

        const { adId } = this.props.match.params

        message.destroy()
        message.success("Success")

        _postPauseAd({ adId })
        .then( res => {
            
            if( res.data.success ){
                this.setState({
                    ad: {
                        ...this.state.ad,
                        status: AD_STATUS.paused
                    }
                })
            }

        })

    }

    handleRemove = () => {

        const { adId } = this.props.match.params
        
        message.destroy()
        message.success("Success")

        _postRemoveAd(adId)
        .then( res => {

            if( res.data.success ){
                this.setState({
                    ad: {
                        ...this.state.ad,
                        removed: true
                    }
                })
            }

        })

    }
}

export default withRouter(EezeeAdsProfilePage)


// WEBPACK FOOTER //
// ./src/containers/eezee-ads-profile-page.js